export default "__VITE_ASSET__DWtTVbC7__"